import { Capacitor } from "@capacitor/core";

/**
 * Base URL for backend requests.
 *
 * - Web builds talk to the same origin, so the base is "" (relative paths).
 * - Native (Capacitor) builds MUST set `VITE_API_URL` at build time (staging or
 *   https://suturia.com). Silent defaults hid misconfigured native shells.
 */
export function resolveApiBase(
  env: { VITE_API_URL?: string | undefined } = import.meta.env,
  isNative: boolean = Capacitor.isNativePlatform(),
): string {
  const override = env.VITE_API_URL?.trim();
  if (override) return override.replace(/\/$/, "");
  if (!isNative) return "";
  throw new Error(
    "Native Capacitor builds require VITE_API_URL (e.g. https://suturia.com or your staging URL).",
  );
}

export const API_BASE: string = (() => {
  try {
    return resolveApiBase();
  } catch (err) {
    // Keep the module loadable in misconfigured native shells so the UI can
    // still render a useful error; network calls will fail clearly.
    console.error(err instanceof Error ? err.message : err);
    return "";
  }
})();
